import styled from "styled-components";

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: #0D71D7;
  cursor: pointer;
  display: flex;
  @media(max-width: 768px) {
    font-size: 14px;
  }
`
export const Arrow = styled.div`
  font-size: 12px;
  margin-top: 2px;
  margin-left: 5px;
`
